import Render from '@Views/root/accounting/aside-accounting.html'
import { Component, Vue } from 'vue-property-decorator'

@Render
@Component({})
export class ASideMain extends Vue {}